import styles from './index.module.sass';
import greenArrow from './icons/green-arrow.svg';
import greyArrow from './icons/grey-arrow.svg';
import { Modal, notification } from 'antd';
import { getMonthCalendar } from './get-month-calendar';
import classNames from 'classnames';
import { ButtonPrimary } from '@/shared/ui/button';
import React, { useRef, useEffect, useState } from 'react';
import {
  formatDateTime,
  isDateNotEarlierThanToday,
  isDateNotLaterThanToday,
} from '@/modules/bags/functions/format-date.function';

export const CalendarPicker = ({
  visible,
  closeFn,
  date: outerDate,
  setDate: setOuterDate,
  allowFutureDate = true,
  allowPastDate,
}: ICalendarPicker) => {
  const [date, setDate] = useState(outerDate);
  const elemRef = useRef<any>(null);
  var months = [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
  ];
  const years = (() => {
    var currentYear = new Date().getFullYear();
    var years = [];
    for (var i = 0; i < 6; i++) {
      years.push(currentYear + i);
    }
    return years;
  })();
  const weekDays = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];
  const hoursInDay = [];

  for (let hour = 0; hour < 24; hour++) {
    const paddedHour = hour.toString().padStart(2, '0');
    hoursInDay.push(String(paddedHour));
  }

  const minutesInHour = [];

  for (let minute = 0; minute < 60; minute++) {
    const paddedMinute = minute.toString().padStart(2, '0');
    minutesInHour.push(paddedMinute);
  }

  const calendarData = getMonthCalendar(date.year, parseFloat(String(date.month)));

  const handleMonth = (type: 'increment' | 'decrement') => {
    if (type === 'increment') {
      if (parseFloat(String(date.month)) > 11) {
        setDate({ ...date, year: date.year + 1, month: 1 });
        return;
      }
      setDate({ ...date, month: parseFloat(String(date.month)) + 1 });
    } else if (type === 'decrement') {
      if (parseFloat(String(date.month)) < 2) {
        setDate({ ...date, year: date.year - 1, month: 12 });
        return;
      }
      setDate({ ...date, month: parseFloat(String(date.month)) - 1 });
    } else {
      date;
    }
  };

  const [showDropdowns, setShowDropdowns] = useState({
    minutes: false,
    hours: false,
    months: false,
    years: false,
  });

  useEffect(() => {
    return () => {
      setShowDropdowns({
        minutes: false,
        hours: false,
        months: false,
        years: false,
      });
    };
  }, [visible]);

  useEffect(() => {
    setDate(outerDate);
  }, [outerDate]);

  return (
    <div className={classNames(styles.root, visible && styles.visible)} ref={elemRef}>
      <div className={styles.topBlock}>
        <div className={styles.controlBar}>
          <img
            src={greenArrow}
            className={styles.prevButton}
            onClick={() => handleMonth('decrement')}
            alt={'prev'}
          />
          <div
            className={styles.monthSelector}
            onClick={() =>
              setShowDropdowns({ ...showDropdowns, months: !showDropdowns.months })
            }
          >
            {months[parseFloat(String(date.month)) - 1]}
            <img
              src={greyArrow}
              alt="more"
              style={showDropdowns.months ? { transform: 'rotate(180deg)' } : {}}
            />
            <div
              className={styles.hours}
              style={
                showDropdowns.months
                  ? { display: 'block', width: 100 }
                  : { display: 'none' }
              }
            >
              <div className={styles.hoursInner}>
                {months.map((item, i) => (
                  <div
                    key={i}
                    className={styles.hourItem}
                    onClick={() => setDate({ ...date, month: i + 1 })}
                  >
                    {item}
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div
            className={styles.yearSelector}
            onClick={() =>
              setShowDropdowns({ ...showDropdowns, years: !showDropdowns.years })
            }
          >
            {date.year}
            <img
              src={greyArrow}
              alt="more"
              style={showDropdowns.years ? { transform: 'rotate(180deg)' } : {}}
            />
            <div
              className={styles.hours}
              style={showDropdowns.years ? { display: 'block' } : { display: 'none' }}
            >
              <div className={styles.hoursInner}>
                {years.map((item) => (
                  <div
                    className={styles.hourItem}
                    onClick={() => {
                      setDate({ ...date, year: +item });
                    }}
                  >
                    {item}
                  </div>
                ))}
              </div>
            </div>
          </div>
          <img
            src={greenArrow}
            className={styles.nextButton}
            onClick={() => handleMonth('increment')}
            alt={'next'}
          />
        </div>
        <div className={styles.daysGrid}>
          <div className={styles.weekGrid}>
            {weekDays.map((item) => (
              <div className={classNames(styles.weekDay, styles.topRow)}>{item}</div>
            ))}
          </div>
          {calendarData &&
            calendarData.map((weekItem) => (
              <div className={styles.weekGrid}>
                {weekItem.map((dayItem) => {
                  // const today =
                  // console.log(date)
                  return (
                    <div
                      onClick={() => {
                        if (!dayItem) return;
                        if (
                          allowFutureDate === false &&
                          !isDateNotLaterThanToday(
                            new Date(date.year, Number(date.month) - 1, dayItem),
                          )
                        ) {
                          return notification.warning({
                            message: 'Предупреждение',
                            description: 'Дата не может быть позднее сегодняшнего дня',
                          });
                        }
                        if (
                          allowPastDate === false &&
                          !isDateNotEarlierThanToday(
                            new Date(date.year, Number(date.month) - 1, dayItem),
                          )
                        ) {
                          return notification.warning({
                            message: 'Предупреждение',
                            description: 'Дата не может быть ранее сегодняшнего дня',
                          });
                        }
                        dayItem &&
                          setDate({
                            ...date,
                            year: date.year,
                            month: date.month,
                            day: dayItem,
                          });
                        setOuterDate({
                          ...date,
                          year: date.year,
                          month: date.month,
                          day: dayItem,
                        });
                      }}
                      className={classNames(
                        styles.weekDay,
                        dayItem === new Date().getDate() &&
                          parseFloat(String(date.month)) - 1 ===
                            new Date().getMonth() &&
                          parseFloat(String(date.year)) === new Date().getFullYear() &&
                          styles.currentDay,
                        dayItem === parseFloat(String(date.day)) &&
                          parseFloat(String(date.month)) ===
                            parseFloat(String(outerDate.month)) &&
                          styles.selectedDay,
                      )}
                    >
                      {dayItem}
                    </div>
                  );
                })}
              </div>
            ))}
        </div>
      </div>

      <div className={styles.bottomBlock}>
        <div className={styles.hourPicker}>
          <div
            className={styles.timeSelector}
            onClick={() =>
              setShowDropdowns({ ...showDropdowns, hours: !showDropdowns.hours })
            }
          >
            {isNaN(parseFloat(String(date.hours))) ||
            parseFloat(String(date.hours)) === 0
              ? '00'
              : parseFloat(String(date.hours)) > 9
              ? parseFloat(String(date.hours))
              : '0' + parseFloat(String(date.hours))}{' '}
            <img src={greyArrow} alt="more" />
            <div
              className={styles.hours}
              style={showDropdowns.hours ? { display: 'block' } : { display: 'none' }}
            >
              <div className={styles.hoursInner}>
                {hoursInDay.map((item) => (
                  <div
                    className={styles.hourItem}
                    onClick={() => {
                      setDate({ ...date, hours: +item });
                      setOuterDate({ ...date, hours: +item });
                    }}
                  >
                    {item}
                  </div>
                ))}
              </div>
            </div>
          </div>
          <span> : </span>
          <div
            className={styles.timeSelector}
            onClick={() => {
              setShowDropdowns({ ...showDropdowns, minutes: !showDropdowns.minutes });
            }}
          >
            {isNaN(parseFloat(String(date.minutes))) || date.minutes === 0
              ? '00'
              : parseFloat(String(date.minutes)) > 9
              ? parseFloat(String(date.minutes))
              : '0' + parseFloat(String(date.minutes))}{' '}
            <img src={greyArrow} alt="more" />
            <div
              className={styles.hours}
              style={showDropdowns.minutes ? { display: 'block' } : { display: 'none' }}
            >
              <div className={styles.hoursInner}>
                {minutesInHour.map((item) => (
                  <div
                    className={styles.hourItem}
                    onClick={() => {
                      setDate({ ...date, minutes: +item });
                      setOuterDate({ ...date, minutes: +item });
                    }}
                  >
                    {item}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <ButtonPrimary
          label="Готово"
          onClick={() => {
            setDate({
              ...date,
              year: date.year,
              month: date.month,
              day: date.day,
            });
            setOuterDate({
              ...date,
              year: date.year,
              month: date.month,
              day: date.day,
            });
            closeFn();
          }}
          className={styles.button}
        />
      </div>
    </div>
  );
};

interface ICalendarPicker {
  visible: boolean;
  closeFn: () => void;
  date: {
    year: number;
    month: number | string;
    day: number | string;
    hours: number | string;
    minutes: number | string;
  };
  setDate: any;
  allowFutureDate?: boolean;
  allowPastDate?: boolean;
}
